module.exports = __webpack_public_path__ + "fonts/SummerLoving.5af882897bc014d9fd94fb7e843f26d1.otf";